import { addGameObject } from './entity';
import { SHADOWS, SHAPE_STYLES } from './constants';
import { ObjectType, Side } from './shared/api_shared_types';
import { setVisibilityState } from './simulate';
import {
  RenderItemType,
  VisibilityState,
  type Entity,
  type GameManager,
  type GameObjectController,
  type ToolTip,
  type V2,
} from './types';
import {
  EMPTY_RENDER_TRANSFORM,
  type RenderPackageItem,
  type RenderPackageTooltipBubble,
} from './render_package';
import logger from './controllers/logger';
import { debugState } from '.';

export function controller(): GameObjectController {
  return {
    getNew: getZeroToolTip,
    sync: null,
    update,
    createPackage,
  };
}

export function getZeroToolTip(ent: Entity): ToolTip {
  return {
    ...ent,
    objectType: ObjectType.TOOLTIP,
    tObj: null,
    btnClose: null,
    flag: '',
    text: [],
    currentPage: 0,
    btnNext: null,
    btnPrev: null,
    onFlagSet: null,
    arrowSide: Side.NONE,
    arrowOffset: 0,
    arrowWidth: 16,
    arrowLength: 10,
    cornerRadius: 12,
    shapeStyle: { ...SHAPE_STYLES.WHITE },
    showNextButton: false,
    shownAt: 0,
    renderShadow: SHADOWS.DEFAULT,
  };
}

export function createAndAddLocalToolTip(manager: GameManager, ent: Entity): ToolTip {
  const tooltip = getZeroToolTip(ent);
  addGameObject(manager, tooltip);
  setVisibilityState(tooltip, VisibilityState.APPEARING);
  return tooltip;
}

export function update(_obj: ToolTip): boolean {
  return false;
}

export function createPackage(obj: ToolTip, position: V2, scale: number): RenderPackageItem[] {
  const bubble: RenderPackageTooltipBubble = {
    type: RenderItemType.tooltip_bubble,
    ...EMPTY_RENDER_TRANSFORM,
    scale,
    positionX: position.x,
    positionY: position.y,
    width: obj.width,
    height: obj.height,
    cornerRadius: obj.cornerRadius,
    arrowSide: obj.arrowSide,
    arrowOffset: obj.arrowOffset,
    arrowWidth: obj.arrowWidth,
    arrowLength: obj.arrowLength,
    shapeStyle: obj.shapeStyle,
    shadow: obj.renderShadow,
  };

  return [bubble];
}
